// Copyright © 2021 Move Closer
/**
 * Configuration for the `<VueScroll>` component.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const VUESCROLL_OPTIONS = {
    ops: {
        bar: { background: '#e51a1a' },
        scrollPanel: { scrollingX: false }
    }
};
